import { Authorization } from './middleware'

export const User = Authorization([1])
